import { useStats } from './useStats'
import { useComplianceAlerts } from './useComplianceAlerts'
import { useDismissedAlerts } from './useDismissedAlerts'

export interface NotificationCount {
  pendingDecisions: number
  criticalAlerts: number
  total: number
  isLoading: boolean
}

/**
 * The number behind the global sidebar / top-bar badge: pending decisions plus
 * unacknowledged critical compliance alerts. Both pieces come from existing
 * endpoints (stats + the compliance-alerts bridge); acknowledged alerts are
 * filtered out locally.
 */
export function useNotificationCount(): NotificationCount {
  const stats = useStats()
  const alerts = useComplianceAlerts()
  const { isDismissed } = useDismissedAlerts()

  const pendingDecisions = stats.data?.pendingDecisions ?? 0
  const criticalAlerts = (alerts.data?.alerts ?? []).filter(
    (a) => a.risk_level === 'critical' && !isDismissed(a.id),
  ).length

  return {
    pendingDecisions,
    criticalAlerts,
    total: pendingDecisions + criticalAlerts,
    isLoading: stats.isLoading || alerts.isLoading,
  }
}
